export default __webpack_public_path__ + "static/media/calender_icon.e60eb776.svg";